const directiveModule: angular.IModule = angular.module("sdDirectives", ["sdEventModule", "sdLogger", "ngSanitize"]);
export default directiveModule;
